const styles = {
  pageContainer: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    width: '100%'
  },
  headerContainer: {
    display: 'flex',
    width: '100%',
    py: 2,
    '@media (max-width: 600px)': {
      flexDirection: 'column',
      alignItems: 'center'
    }
  },
  headerTitle: {
    width: '60%',
    '@media (max-width: 600px)': {
      flexGrow: 1,
      mb: 2,
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center'
    }
  },
  datePickerContainer: {
    flexGrow: 1,
    ml: 2,
    display: 'flex',
    justifyContent: 'flex-start',
    '@media (max-width: 600px)': {
      ml: 0,
      width: '100%',
      justifyContent: 'center',
      marginBottom: '8px'
    }
  },
  exportButtonContainer: {
    flexGrow: 1,
    mr: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    '@media (max-width: 600px)': {
      justifyContent: 'center'
    }
  },
  analyticsContainer: {
    marginX: -2,
    paddingX: 0,
    display: 'flex',
    flex: 1,
    marginBottom: -2,
    '@media screen and (min-width: 768px)': {
      paddingX: 2
    },
    boxShadow: 'none',
    mt: 2
  },
  innerAnalyticsContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  errorCard: {
    m: 1,
    p: 1,
    display: 'flex',
    justifyContent: 'center',
    width: 400,
    height: 400
  },
  performanceTab: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    justifyContent: 'center'
  },
  tabContainer: {
    backgroundColor: '#e0e0e0',
    borderRadius: 1,
    p: 0.5,
    width: '100%',
    maxWidth: 700,
    overflowX: 'auto'
  },
  mobileTabScroll: {
    '.MuiTabs-flexContainer': {
      alignItems: 'flex-start'
    },
    '& .MuiTab-root': {
      textAlign: 'left',
      justifyContent: 'flex-start',
      maxWidth: 'none',
      width: '100%'
    },
    '& .MuiTabs-scrollButtons': {
      display: 'flex !important'
    }
  },
  tabIndicatorProps: {
    style: {
      backgroundColor: 'white',
      height: '100%',
      borderRadius: 4,
      transition: 'all 0.3s ease'
    }
  },
  tab: {
    minHeight: 0,
    py: 1,
    zIndex: 1,
    textTransform: 'none'
  }
};

export default styles;
